import { http } from 'services/http';
import { TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys';
import type { TMergeTripTasksReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

export const useMergeTripTasks = (tripId: number) => {
  return useMutationBase<unknown, unknown, TMergeTripTasksReq>({
    mutationFn: async (variables) => {
      await http.post(`/v1/trips/${tripId}/trip-tasks/merge`, variables);
    },
    invalidateCallback: () => [
      [TRIP_TASKS_GET_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
